import React from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Slide } from '@wds/motion';
import { Button } from '@wds/button';

import PropTypes from 'prop-types';
import STRINGS from '../constants';
// import RecoveryCodes from './RecoveryCodes'; // Commented out - backup codes feature disabled

const EnrollmentComplete = (props) => {
	const {
		currentPage,
		isLoaded,
		context,
		error,
		isSliding,
		setIsSliding,
		handleOnFinish,
		finishBtnTxt,
	} = props;

	return (
		<Slide
			in={isLoaded && currentPage === 'enrollment-complete'}
			speed={currentPage === 'enrollment-complete' ? 'slow' : undefined}
			timeout={currentPage === 'enrollment-complete' ? undefined : 150}
			direction='right'
			onEnter={() => setIsSliding(true)}
			onExited={() => setIsSliding(false)}
			alwaysRenderContent
		>
			<Box
				display='flex'
				flexDirection='column'
				alignItems='center'
				style={{
					position: isSliding ? 'absolute' : 'static',
					width: '100%'
				}}
			>
				{/* Container for Text and Button */}
				<Box
					style={{
						width: '100%',
						maxWidth: '440px',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'stretch',
					}}
				>
					{/* Header Text */}
					<Box mb={4}>
						<Typography
							variant='h4'
							style={{
								fontSize: '22px',
								fontWeight: '700',
								marginBottom: '12px',
								color: '#111827',
								textAlign: 'left'
							}}
						>
							{STRINGS.allSet}
						</Typography>
						<Typography
							style={{
								fontSize: '14px',
								color: '#6B7280',
								lineHeight: '1.6',
								textAlign: 'left'
							}}
						>
							{STRINGS.whenYouLoginMFA}
							{' '}
							<Typography
								component='a'
								variant='link'
								href={window.LOCALE?.mfaLearnMore}
								target='_blank'
								rel='noopener noreferrer'
								style={{
									color: '#007FAA',
									textDecoration: 'none'
								}}
							>
								{STRINGS.learnMoreAboutManagingMFA}
							</Typography>
						</Typography>
					</Box>

					{/* Button */}
					<Button
						id='finish-button'
						onClick={handleOnFinish}
						style={{
							width: '100%',
							height: '48px',
							backgroundColor: '#008000',
							color: '#FFFFFF',
							fontSize: '15px',
							fontWeight: '600',
							borderRadius: '4px',
							border: 'none',
							cursor: 'pointer'
						}}
					>
						{finishBtnTxt || STRINGS.continue}
					</Button>
				</Box>
				{/* Recovery Codes feature - currently disabled */}
				{/* Uncomment below to re-enable recovery codes display */}
				{/*
				<RecoveryCodes
					codes={context.recovery_codes}
					error={error}
					showFinishButton={false}
				/>
				*/}
			</Box>
		</Slide>
	);
};

EnrollmentComplete.propTypes = {
	isLoaded: PropTypes.bool.isRequired,
	context: PropTypes.object.isRequired,
	isSliding: PropTypes.bool.isRequired,
	setIsSliding: PropTypes.func.isRequired,
	currentPage: PropTypes.string.isRequired,
	handleOnFinish: PropTypes.func.isRequired,
	finishBtnTxt: PropTypes.string.isRequired,
};

export default EnrollmentComplete;
